import { render, staticRenderFns } from "./member-form-readonly.vue?vue&type=template&id=68d0cb6d"
import script from "./member-form-readonly.vue?vue&type=script&lang=js"
export * from "./member-form-readonly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports